import { __decorate, __metadata, __param } from "tslib";
import { fetchEcomSetting } from '@gn-audio/core/api/site-settings/fetch-ecom-setting';
import { Directive, Inject } from 'angular-ts-decorators';
var EcomStateDirective = (function () {
    function EcomStateDirective($element) {
        this.$element = $element;
    }
    EcomStateDirective.prototype.ngOnInit = function () {
        var _this = this;
        fetchEcomSetting()
            .then(function (ecomSetting) {
            _this.$element.addClass(ecomSetting.ecomEnabled ? 'ecom-enabled' : 'ecom-disabled');
        });
    };
    EcomStateDirective.$inject = ['$element'];
    EcomStateDirective = __decorate([
        Directive({
            selector: '[ecomState]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], EcomStateDirective);
    return EcomStateDirective;
}());
export { EcomStateDirective };
